module.exports = __webpack_public_path__ + "img/smao2.42679ab0.jpg";